import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { SearchResults } from '../../../services/search.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {
  @Input() model: SearchResults;
  @Input() searchTerm: string;

  constructor() {
  }

  ngOnInit() {

  }

  goToResult() {
    if (this.model.Url.includes('https://') || this.model.Url.includes('http://') || this.model.Category == 'newTab') {
      window.open(this.model.Url, "_vesta");
    } else {
      window.location.href = window.location.origin + this.model.Url + "#" + this.model.SectionId;
    }
  }
}
